<template>
  <Section class="outro" type="yellow">
    <div class="outro__image"></div>
    <Heading class="outro__heading">All done! Enjoy the good karma.</Heading>
    <Description class="outro__desc">
        Karma bot is a chatbot that collects and processes in-chat data to build comprehensive performance reports and improve people culture.
        It lifts up the team morale while providing valuable insights for the leaders.
    </Description>
    <Action>
      <a href="https://karmabot.chat/?source=discord2slack" class="btn btn--white">Learn more</a>
    </Action>
  </Section>
</template>

<script>
  import Section from './UI/Section'
  import Heading from './UI/Heading'
  import Description from './UI/Description'
  import Action from './UI/Action'

  export default {
    components: {
      Section,
      Heading,
      Description,
      Action
    }
  }
</script>

<style lang="scss" scoped>
  @import '../assets/styles/utils.sass';

  .outro {
    @include image('finalbg.svg');
    background-size: cover;
    background-position: center center;
  }

  .outro__image {
    width: 200px;
    height: 200px;
    margin: -10px auto 30px;
    @include image('karmabot-like-1.png');
    background-size: cover;
  }

  .outro__heading {
    color: #552d18;
  }

  .outro__desc {
    color: #6d4b34;
  }
</style>
